<template>
    <!-- <header class="logo-env" :class="{'logo-env--lms' : currentRouteBase}"> -->
    <header class="logo-env logo-env--lms">
        <div class="logo">
            <router-link to="/">
                <!-- <template v-if="!currentRouteBase">
                    {{ $t("source") }}
                </template> -->

                <img
                    v-if="globalLogo"
                    :src="env.media_url + '/' + globalLogo"
                    alt="School"
                >
                <img
                    v-else
                    :src="env.public_base + '/assets/images/sourcelms-logo.svg'"
                    width="160"
                    height="30"
                    alt="School"
                >

               <!-- <img :src="env.public_base + '/assets/images/jerelo-logo.png'" alt=""> -->
                <!-- <img v-if="currentRouteBase" :src="env.public_base + '/assets/images/sourcelms-logo.svg'" alt="School"> -->
            </router-link>
        </div>

        <!--add class "sidebar-collapse" to collapse-->
        <div class="sidebar-collapse" @click="toggleSidebarMenu">
            <a href="javascript:void(0)" class="sidebar-collapse-icon">
                <i class="entypo-menu"></i>
            </a>
        </div>

        <!-- open/close menu icon (do not remove if you want to enable menu on mobile devices) -->
        <div class="sidebar-mobile-menu visible-xs" @click="toggleSidebarMenu">
            <a href="javascript:void(0)" class="with-animation">
                <i class="entypo-menu"></i>
            </a>
        </div>
    </header>
</template>

<script>
    import {mapGetters} from 'vuex';
    import env from "../../env";

    export default {
        data() {
            return {
                env,
                sidebarMenu: false,
                globalLogo: window.school_logo,
            }
        },

        computed: {
            ...mapGetters([
                'sidebarStateLeft'
            ]),
            currentRouteBase() {
                return location.host === 'demo.sourcelms.com'
            },
        },

        methods: {
            toggleSidebarMenu() {
                this.sidebarMenu = !this.sidebarMenu;

                this.$store.dispatch('toggleSidebarLeft', !this.sidebarStateLeft);
            }
        },
    }
</script>
